import { render } from "./menuFW.vue?vue&type=template&id=75c14c0c"
import script from "./menuFW.vue?vue&type=script&lang=js"
export * from "./menuFW.vue?vue&type=script&lang=js"

import exportComponent from "/Users/oscar/Desarrollo/Vue.js/Anfora/FrontEnd/FastWayAnfora/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__